define('visitorIdCookie',[], function () {

    function VisitorIdCookie() { }

    VisitorIdCookie.CheckAndSetCookie = function()
    {
        const COOKIE_NAME = 'SitecoreVisitorId';
        const RESPONSE_MAX_AGE = 60 * 60 * 24 * 365;

        const cookies = Object.fromEntries(document.cookie.split('; ').map(c => c.split('=')));

        let visitorId = cookies[COOKIE_NAME];
        if (!visitorId) {
            visitorId = crypto.randomUUID();
            let cookieVal = `${COOKIE_NAME}=${visitorId}; Path=/;`;// HttpOnly;`;// Secure;`;// SameSite=Lax;`;// Max-Age=${RESPONSE_MAX_AGE}`;

            document.cookie = cookieVal;
            console.log(`Set ${COOKIE_NAME} cookie to be ${visitorId}`);
        }
    }

    return VisitorIdCookie;
});

